module.exports = __webpack_public_path__ + "img/800x600.1170bd79.svg";